<template>
    <div id="app">
        <div class="header">
            <!-- 头部搜索条件 -->
            <genjinCondition
                    :select3Val.sync="select3Val"
                    :yueling1.sync="yueling1"
                    :yueling2.sync="yueling2"
                    :now_time.sync="now_time"
                    :vip_name.sync="vip_name"
                    :cabeza_name.sync="cabeza_name"
                    :cabeza_tel.sync="cabeza_tel"
                    :selectVal.sync="selectVal"
                    :usertypeVal.sync="usertypeVal"
                    :select_Val.sync="select_Val"
                    :show_zj="show_zj"
                    :options="options"
                    :option2="option2"
                    @doSearch="getData"
                    @clear_search="clear_search"
                    @doSearch_2="getData(1, 2)"
                    @getStatus="getStatus"
            ></genjinCondition>

            <br/>
            <hr/>
            <br/>
            <a :href="export_url" target="_blank" class="btn btn-success btn-xs"
               style="float: right;padding: 5px 14px;height: 30px;margin:0 20px 5px 20px">导出excel</a>
            <el-button
                    style="float: right;padding: 8px 14px;background-color: #E6BE8A;border: 1px solid #E6BE8A;"
                    size="mini"
                    @click="fn(1)"
            >导入潜客
            </el-button>

            <a class="el-button el-button--primary el-button--mini"
               :href="baseUrl + 'saas/user/xiaz'"
               target="_blank"
               style="float: right;padding: 8px 14px;background-color: #E6BE8A;border: 1px solid #E6BE8A;">
                下载导入模板
            </a>

            <el-button
                    size="mini"
                    @click="jump"
                    style="float: right;padding: 8px 14px;background-color: #E6BE8A;border: 1px solid #E6BE8A;"
            >新增潜客
            </el-button>

            <el-dialog title="删除所属顾问" :visible.sync="centerDialogVisible" width="30%" center>
                <span>确认将顾问：{{select_name}}下的所有用户（{{market_num}}人）重新分配？且不可恢复</span>
                <span slot="footer" class="dialog-footer">
          <el-button @click="centerDialogVisible = false">取 消</el-button>
          <el-button type="warning" @click="del_market">确 定</el-button>
        </span>
            </el-dialog>

            <form method="post" enctype="multipart/form-data" id="formbox" style="display: none">
                <div style="width: 200px;width:200px;background: red"></div>
                <input type="text" v-model="token" name="token" style="display: none"/>
                <input type="text" id="txt1" name="type" value="1"/>
                <input
                        type="file"
                        id="fil"
                        name="ex"
                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        @change="tijiao(1)"
                        style="display: none"
                />
            </form>
        </div>

        <el-table
                :data="tableData"
                border
                style="width: 100%"
                :cell-style="getClass"
                @selection-change="handleSelectionChange"
                @sort-change="getSortChange"
        >
            <el-table-column type="selection" width="40"></el-table-column>
            <el-table-column prop="gj_type" label="状态" width="100"></el-table-column>
            <el-table-column label="创建时间" width="100">
                <template slot-scope="scope">
                    <span>{{ scope.row.create_time ? scope.row.create_time : '--' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="会员姓名" width="90">
                <template slot-scope="scope">
          <span
                  style="cursor: pointer;"
                  @click="pop(scope.row.user_id)"
          >{{ scope.row.baobao_name ? scope.row.baobao_name : '--' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="家长姓名" width="90">
                <template slot-scope="scope">
                    <span>{{ scope.row.p_name ? scope.row.p_name : '--' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="电话" width="110">
                <template slot-scope="scope">
                    <span>{{ scope.row.p_phone ? scope.row.p_phone : '--' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="会员生日" width="100">
                <template slot-scope="scope">
                    <span>{{ scope.row.baobao_birthday ? scope.row.baobao_birthday : '--' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="上次跟进" width="110" sortable="custom">
                <template slot-scope="scope">
                    <span>{{ scope.row.last ? scope.row.last : '--' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="顾问" width="100">
                <template slot-scope="scope">
                    <span>{{ scope.row.username ? scope.row.username : '--' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="来源" width="100">
                <template slot-scope="scope">
                    <span>{{ scope.row.laiyuan ? scope.row.laiyuan : '--' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="跟进记录">
                <template slot-scope="scope">
          <span
                  style="display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;"
          >{{ scope.row.neirong ? scope.row.neirong : '--' }}</span>
                </template>
            </el-table-column>
        </el-table>

        <!--修改弹出框-->
        <form id="forms" action method="post">
            <el-dialog title="修改潜客信息" :visible.sync="dialogVisible" width="600px" style="text-align:left">
                <label style="margin: 0 5px 0 20px;">姓名</label>
                <input
                        type="text"
                        class="save-input"
                        style="margin-right: 90px;"
                        v-model="save_list2.baobao_name"
                        placeholder="请输入会员姓名"
                        name="baobao_name"
                        value
                />
                <label>别名</label>
                <input
                        type="text"
                        class="save-input"
                        placeholder="请输入会员别名"
                        v-model="save_list2.baobao_name2"
                        name="baobao_name2"
                        value
                />
                <br/>

                <label style="margin: 0 5px 0 20px;">生日</label>

                <el-date-picker
                        value-format="yyyy-MM-dd"
                        v-model="save_list2.baobao_birthday"
                        name="baobao_birthday"
                        size="mini"
                        type="date"
                        placeholder="选择日期"
                ></el-date-picker>

                <label style="margin-left: 90px;">性别</label>
                <el-radio name="baobao_sex" v-model="save_list2.baobao_sex" label="男">男</el-radio>
                <el-radio name="baobao_sex" v-model="save_list2.baobao_sex" label="女">女</el-radio>
                <br/>

                <label style="margin: 0 5px 0 20px;">来源</label>
                <select
                        name="laiyuan"
                        v-model="save_list2.laiyuan"
                        style="width: 159px;height:28px;margin-top: 10px;"
                        class="save-input"
                >
                    <option v-for="item in option2" :value="item.label">{{item.label}}</option>
                </select>
                <label style="margin-left: 90px;">备注</label>
                <input
                        type="text"
                        class="save-input"
                        placeholder="请输入备注"
                        v-model="save_list2.beizhu"
                        name="beizhu"
                        value
                />
                <br/>

                <label style="margin: 0 5px 0 20px;">地址</label>
                <select
                        name="sheng"
                        v-model="sheng"
                        @change="shengxuan"
                        class="save-input"
                        style="width: auto;margin-top: 10px;"
                >
                    <option v-for="shitem in shiqu" :value="shitem.REGION_ID">{{shitem.REGION_NAME}}</option>
                </select>
                <select
                        name="coun"
                        v-model="shi"
                        @change="shixuan"
                        class="save-input"
                        style="width: auto;margin-top: 10px;"
                >
                    <option v-for="shitem2 in shiqu2" :value="shitem2.REGION_ID">{{shitem2.REGION_NAME}}</option>
                </select>

                <select name="qu" v-model="qu" class="save-input" style="width: auto;margin-top: 10px;">
                    <option v-for="shitem3 in shiqu3" :value="shitem3.REGION_ID">{{shitem3.REGION_NAME}}</option>
                </select>
                <div style="padding-top: 8px">
                    <label style="margin: 10px 5px 0 20px;">详细地址：</label>
                    <textarea name="site" v-model="dz" class="ditialTxt"></textarea>
                </div>

                <label style="margin: 20px 5px 0 20px;">家长联系方式</label>
                <input type="hidden" name="user_id" value v-model="save_list2.user_id"/>
                <input type="hidden" name="token" value v-model="token"/>

                <i class="el-icon-circle-plus-outline" @click="addGuanxi"></i>
                <div
                        class="line"
                        style="margin: 6px 0 0 18px; position: relative"
                        v-for="(item,index) in save_list"
                        :key="index+item.g_value+200"
                >
                    <!-- 不可修改遮罩层 -->
                    <div v-if="show_zj != 1" style="position: absolute; width:100%; height:100%"></div>

                    <span>关系</span>
                    <select
                            @change="checkRelation($event)"
                            name="guanxi[]"
                            v-model="item.g_value"
                            style="width: 100px;height: 28px;margin-right: 10px;"
                            class="save-input"
                    >
                        <option v-for="item in relation" :value="item.value" :key="item.value">{{item.name}}</option>
                    </select>

                    <span>姓名</span>
                    <input
                            type="text"
                            placeholder="请输入家长姓名"
                            style="width: 105px;margin-right: 10px;"
                            v-model="item.p_name"
                            class="save-input"
                            name="name[]"
                            value
                    />

                    <span>联系电话</span>
                    <input
                            type="tel"
                            placeholder="请输入家长电话"
                            maxlength="11"
                            style="width: 105px;"
                            v-model="item.p_phone"
                            class="save-input"
                            name="phone[]"
                            value
                            @blur="checkPhone($event,index)"
                    />
                    <i
                            class="el-icon-remove-outline"
                            @click="delGuanxi(index)"
                            v-if="show_zj === 1 && save_list.length > 1? true : false"
                    ></i>
                </div>

                <div class="line" style="margin: 6px 0 0 18px;" v-for="i in guanxiNum" :key="i+100">
                    <span>关系</span>
                    <select
                            @change="checkRelation($event)"
                            name="guanxi[]"
                            style="width: 100px;height: 28px;margin-right: 10px;"
                            class="save-input"
                    >
                        <option v-for="item in relation" :value="item.value" :key="item.value">{{item.name}}</option>
                    </select>

                    <span>姓名</span>
                    <input
                            type="text"
                            placeholder="请输入家长姓名"
                            style="width: 105px;margin-right: 10px;"
                            class="save-input"
                            name="name[]"
                            value
                    />

                    <span>联系电话</span>
                    <input
                            type="tel"
                            placeholder="请输入家长电话"
                            maxlength="11"
                            style="width: 105px;"
                            class="save-input"
                            name="phone[]"
                            @blur="checkPhone($event,index)"
                            value
                    />

                    <i class="el-icon-remove-outline" @click="delGuanxi"></i>
                </div>

                <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="warning" @click="confirm_save">确 定</el-button>
        </span>
            </el-dialog>
        </form>

        <!--分页-->
        <div style="margin-top: 15px;">
            <el-button
                    v-if="show_zj == 1"
                    size="mini"
                    type="warning"
                    style="float: left;margin-right: 15px;"
                    @click="del"
            >删除所属顾问
            </el-button>
            <el-button
                    size="mini"
                    type="warning"
                    @click="move"
                    style="float: left;margin-right: 15px;"
            >转给他人
            </el-button>
            <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    background
                    :page-size="10"
                    prev-text="上一页"
                    next-text="下一页"
                    :total="totalNum"
            ></el-pagination>
        </div>

        <!--转给他人-->
        <el-dialog title="提示" center top="25vh" :visible.sync="DialogVisible" width="25%">
            <span style="color: red;vertical-align: middle;">*</span>
            <label>选择销售：</label>
            <select name v-model="sell_name" style="width: 250px;height: 30px;">
                <option value>请选择销售</option>
                <option v-for="(item,index) in sellData" :value="item.user_id">{{ item.username }}</option>
            </select>
            <span slot="footer" class="dialog-footer">
        <el-button @click="DialogVisible = false" size="mini">取 消</el-button>
        <el-button type="warning" @click="confirm_move" size="mini">确 定</el-button>
      </span>
        </el-dialog>

        <!--退回公海-->
        <el-dialog title="提示" center class="back_dialog" :visible.sync="send_state" width="25%">
            <span>确定删除此学员？</span>
            <span slot="footer" class="dialog-footer">
        <el-button @click="send_state = false" size="mini">取 消</el-button>
        <el-button type="warning" @click="confirm_back" size="mini">确 定</el-button>
      </span>
        </el-dialog>

        <!--潜客详细信息-->
        <transition name="fade">
            <div v-show="popShow">
                <div @click="popShow = false" class="close-pop"></div>
                <div class="right-pop">
                    <div style="width: calc(100%-800px);"></div>
                    <div></div>
                    <div class="head">
                        <img src="/static/qmsj/img/genjin/boshi.png" class="head-img"/>
                        <span class="name">{{popData.baobao_name ? popData.baobao_name : '--'}}</span>
                        <div class="right">
<!--                            <span class="move" @click="jumpqian('huiyuanqianxin')">早教签约</span>-->
<!--                            <span class="move" @click="jumpqian('tuoyuqianyue')">托育签约</span>-->
                            <span class="move" @click="void_user">无效用户</span>
                            <span class="move" @click="send_state = true">删除</span>
                            <img
                                    src="/static/qmsj/img/genjin/Close.png"
                                    @click="popShow = false"
                                    class="close"
                            />
                        </div>

                        <div class="head_content">
                            <span>最后跟进时间：{{popData.lasttime ? popData.lasttime : '--'}}</span>
                            <span>下次跟进时间：{{popData.lastgjtime ? popData.lastgjtime : '--'}}</span>
                            <span>跟进状态：{{popData.gj_type ? popData.gj_type : '--'}}</span>
                            <br/>
                            <span>负责销售：{{popData.gwname ? popData.gwname : '--'}}</span>
                            <span>采单人：{{popData.cdname ? popData.cdname : '--'}}</span>
                            <span>
                用户分类：
                <input
                        type="text"
                        v-model="t_name"
                        style="width: 80px;border-style: none; border-bottom-style: solid; outline: none;"
                        @focus="showtype=true"
                        @blur="blurs"
                />
                <button v-if="showtype&&showtype2" class="fencss" @click="get_type2(1)">保存</button>
                <button v-if="showtype&&!showtype2" class="fencss" @click="get_type2(2)">修改</button>
              </span>
                        </div>
                    </div>
                    <!--tab切换-->
                    <el-tabs v-model="activeName" type="border-card">
                        <el-tab-pane name="first" label="详细信息">
                            <el-button
                                    size="mini"
                                    style="float: right;"
                                    type="warning"
                                    @click="update(record_id)"
                            >修改信息
                            </el-button>
                            <!-- 展示信息的组件 -->
                            <genjinInfoBox :popData="popData"></genjinInfoBox>

                        </el-tab-pane>

                        <el-tab-pane name="second" label="跟进记录">
                            <textarea v-model="text_val" placeholder="新建跟进记录...(必填，限200字)" name rows cols></textarea>
                            <form class="down_form">
                                <select name v-model="way_val" style="width: 12%;height: 27px;float: left;">
                                    <option value>跟进方式</option>
                                    <option v-for="item in way" :value="item.name">{{item.name}}</option>
                                </select>

                                <el-date-picker
                                        value-format="yyyy-MM-dd"
                                        v-model="make_time"
                                        size="mini"
                                        type="date"
                                        placeholder="预约到访时间"
                                ></el-date-picker>


                                <el-date-picker
                                        value-format="yyyy-MM-dd"
                                        v-model="last_time"
                                        size="mini"
                                        type="date"
                                        placeholder="下次跟进时间"
                                ></el-date-picker>

                                <select
                                        name
                                        v-model="follow_val"
                                        @change="update_gj_type"
                                        style="height: 27px;margin-left: 5px;"
                                >
                                    <option value>跟进状态</option>
                                    <option
                                            v-for="item in option1"
                                            :value="item.content"
                                            :key="item.content"
                                    >{{item.content}}
                                    </option>
                                </select>
                                <input type="button" class="issue" name id @click="issue" value="发布"/>

                                <!--跟进记录-->
                                <div class="record-content" v-for="(item,index) in recordData" v-if="recordData">
                                    <div class="record">
                                        <span>跟进时间: {{item.create_time ? item.create_time : '--'}}</span>
                                        <span>预约时间: {{item.st_time ? item.st_time : '--'}}</span>
                                        <span>
                      跟进方式: {{item.fangshi ? item.fangshi : '--'}}
                      <button
                              :class="item.visittype=='已到访' ? 'yet' : 'not'"
                              @click="visit(item.gj_id)"
                              v-show="item.st_time"
                      >{{item.visittype}}</button>
                    </span>
                                    </div>
                                    <img src="/static/qmsj/img/genjin/header.png" class="header-img"/>
                                    <span class="img-txt">{{item.username ? item.username : '--'}}</span>
                                    <span class="right-txt" @click="del_record(item.gj_id)">删除</span>
                                    <div class="content">{{item.neirong ? item.neirong : '--'}}</div>
                                </div>
                            </form>
                        </el-tab-pane>
                    </el-tabs>
                    <div style="border-bottom: 1px solid gainsboro;"></div>
                </div>
            </div>
        </transition>

        <!--删除跟进记录-->
        <el-dialog title="删除" :visible.sync="del_dialogVisible" width="25%">
            <span>是否删除此条记录？</span>
            <span slot="footer" class="dialog-footer">
        <el-button @click="del_dialogVisible = false" size="mini">取 消</el-button>
        <el-button type="warning" @click="confirm_del" size="mini">确 定</el-button>
      </span>
        </el-dialog>
        <el-dialog class="tanchuang" :visible.sync="dialogVisible3" width="300px">
            <span slot="title" class="dialog-footer">导入潜客情况</span>
            <div>
                导入成功{{chengt}}条，导入失败{{shibait}}条，
                <a :href="xzurl" target="_blank" download>下载错误日志</a>
            </div>
            <span slot="footer" class="dialog-footer"></span>
        </el-dialog>
    </div>
</template>

<script>
    import genjinCondition from "../../components/genjinCondition";
    import genjinInfoBox from "../../components/genjinInfoBox";

    export default {
        components: {genjinCondition, genjinInfoBox},
        data() {
            return {
                token: "",
                baseUrl: '',
                activeName: "second",
                now_time: "", //日期
                //分页
                totalNum: 0,
                currentPage: 1,
                show_zj: 2,
                //表格
                vip_name: "",
                cabeza_name: "",
                cabeza_tel: "",
                selectVal: "",
                usertypeVal: "",
                select_Val: "",
                select3Val: "",
                select_name: "",
                popData: [],
                recordData: [], //跟进记录
                record_id: "",
                sell_name: "",
                sellData: [],
                popShow: false,
                dialogVisible: false,
                DialogVisible: false,
                centerDialogVisible: false,
                market_num: 0, //顾问数量
                option1: [
                    {
                        name: "新客户"
                    },
                    {
                        name: "重点关注"
                    },
                    {
                        name: "新分配"
                    },
                    {
                        name: "已跟进"
                    },
                    {
                        name: "持续跟进"
                    },
                    {
                        name: "预约未到访"
                    },
                    {
                        name: "已到访"
                    },
                    {
                        name: "鱼池"
                    },
                    {
                        name: "定金"
                    }
                ],
                relation: [
                    {
                        name: "爸爸",
                        value: 1
                    },
                    {
                        name: "妈妈",
                        value: 2
                    },
                    {
                        name: "爷爷",
                        value: 3
                    },
                    {
                        name: "奶奶",
                        value: 4
                    },
                    {
                        name: "姥爷",
                        value: 5
                    },
                    {
                        name: "姥姥",
                        value: 6
                    }
                ],
                option2: "",
                way: [
                    {
                        name: "电话"
                    },
                    {
                        name: "微信"
                    },
                    {
                        name: "短信"
                    },
                    {
                        name: "到店"
                    },
                    {
                        name: "其它"
                    }
                ],
                week: [
                    {
                        name: "星期一",
                        value: 1
                    },
                    {
                        name: "星期二",
                        value: 2
                    },
                    {
                        name: "星期三",
                        value: 3
                    },
                    {
                        name: "星期四",
                        value: 4
                    },
                    {
                        name: "星期五",
                        value: 5
                    },
                    {
                        name: "星期六",
                        value: 6
                    },
                    {
                        name: "星期日",
                        value: 7
                    }
                ],
                follow_type: [
                    {
                        name: "重点关注"
                    },
                    {
                        name: "已跟进"
                    },
                    {
                        name: "持续跟进"
                    },
                    {
                        name: "预约未到访"
                    },
                    {
                        name: "已到访"
                    },
                    {
                        name: "鱼池"
                    },
                    {
                        name: "定金"
                    }
                ],
                courseData: [], //班级名称
                text_val: "", //跟进内容
                way_val: "", //跟进方式
                week_val: "", //跟进日期
                make_time: "", //预约时间
                last_time: "", //下次跟进时间
                follow_val: "", //跟进状态
                course_val: "", //选择班级名称
                options: [],
                tableData: [],
                //修改弹出框
                radio: "男",
                save_list: [],
                save_list2: [],
                del_dialogVisible: false, //删除记录
                del_id: "", //删除记录ID
                send_state: false, //退回公海
                multipleSelection: [], //多选框
                showtype: false, //是否显示用户分类
                showtype2: false, //是否显示用户分类
                t_name: "", //用户分类
                time_s: "",
                time_e: "",
                file1: "",
                xzurl: "",
                filobj: "",
                chengt: "",
                shibait: "",
                dialogVisible3: false,
                yueling1: "",
                yueling2: "",
                isSubmit: false,
                // 地址
                shiqu: "",
                shiqu2: "",
                shiqu3: "",
                sheng: "",
                shi: "",
                qu: "",
                dz: "",
                guanxiNum: 0,
                export_url: process.env.apiUrl + "saas/qk/export_qkgj?token=",
                phoneRepeat: false, // 修改潜客信息时判断手机号码是否重复
                orderby:''  //上次跟进时间排序 默认不使用  升序ascending  降序descending
            };
        },
        created() {
            let that = this;
            that.baseUrl = process.env.apiUrl
            $.ajax({
                url: process.env.apiUrl + "saas/qk/is_zongjian",
                type: "post",
                data: {
                    token: that.$cookies.get("token")
                },
                success: function (res) {
                    if (res.status == 1) {
                        that.show_zj = res.show_zj;
                    } else {
                        console.log(res.msg);
                    }
                }
            });

            //市区
            $.ajax({
                type: "POST",
                url: process.env.apiUrl + "saas/User/city",
                data: {
                    token: that.$cookies.get("token"),
                    user_id: that.uid
                },
                success: function (data) {
                    that.shiqu = data;
                },
                error: function () {
                    that.$message.error(`请求失败`);
                }
            });
        },
        mounted() {
            this.token = this.$cookies.get("token");
            this.export_url = process.env.apiUrl + "saas/qk/export_qkgj?token=" + this.token + "&time_s=" + this.time_s
                + "&time_e=" + this.time_e + "&name=" + this.vip_name + "&pname=" + this.cabeza_name + "&pphone=" + this.cabeza_tel
                + "&type=" + this.selectVal + "&usertype=" + this.usertypeVal + "&salesperson=" + this.select_Val + "&laiy=" + this.select3Val + "&yueling1=" + this.yueling1 + "&yueling2=" + this.yueling2
            this.getData();
            this.get_laiyuan();
            this.get_sales();
        },
        methods: {
            //执行上次跟进时间排序
            getSortChange(custom){
                this.orderby = custom.order
                this.getData()

            },
            // 从子组件传递回来的 跟进状态 数组
            getStatus(data) {
                this.option1 = data;
            },
            //执行导入潜客
            tijiao: function (type) {
                const loading = this.$loading({
                    lock: true,
                    text: "导入中...",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)"
                });
                let formData = "";
                if (type == 1) {
                    formData = new FormData($("#formbox")[0]);
                } else {
                    formData = new FormData($("#formbox2")[0]);
                }
                let self = this;
                $.ajax({
                    type: "POST",
                    url: process.env.apiUrl + "saas/User/uploadFile",
                    data: formData,
                    contentType: false,
                    processData: false,
                    dataType: "json",
                    success: function (data) {
                        loading.close();
                        if (data.status == 3) {
                            self.$message.success(
                                `导入潜客成功!导入成功${data.success}条，导入失败${data.err}条`
                            );
                        } else if (data.status == 4) {
                            self.chengt = data.success;
                            self.shibait = data.err;
                            self.xzurl = data.xzurl;
                            self.dialogVisible3 = true;
                            self.file1 = data.file;
                        } else if (data.status == 5) {
                            self.$message.error(`未选择文件`);
                        }
                        if (type == 1) {
                            $("#fil").remove();
                            $("#txt1").after(self.filobj);
                            $("#fil").change(function () {
                                self.tijiao(1);
                            });
                        } else {
                            $("#fil2").remove();
                            $("#txt2").after(self.filobj);
                            $("#fil2").change(function () {
                                self.tijiao(2);
                            });
                        }
                    },
                    error: function () {
                        loading.close();
                        self.$message.error(`上传失败，请检查网络后重试`);
                    }
                });
            },
            //调用导入潜客
            fn: function (type) {
                if (type == 1) {
                    this.filobj = $("#fil").clone();
                    $("#fil")
                        .get(0)
                        .click();
                } else {
                    this.filobj = $("#fi2").clone();
                    $("#fil2")
                        .get(0)
                        .click();
                }
            },
            //切换跟进状态
            update_gj_type() {
                let that = this;
                $.ajax({
                    url: process.env.apiUrl + "saas/nn/update_gj_type",
                    type: "post",
                    data: {
                        token: that.token,
                        user_id: that.record_id,
                        gj_type: that.follow_val
                    },
                    success: function (e) {
                    }
                });
            },
            // 来源下拉
            get_laiyuan() {
                let that = this;
                $.ajax({
                    url: process.env.apiUrl + "saas/index/get_source",
                    type: "post",
                    data: {
                        token: that.token
                    },
                    success: function (e) {
                        that.option2 = e.data;
                    }
                });
            },
            //销售
            get_sales() {
                let that = this;
                $.ajax({
                    url: process.env.apiUrl + "saas/nn/sales",
                    type: "post",
                    data: {
                        token: that.token
                    },
                    success: function (data, status) {
                        that.options = data.data;
                    },
                    fail: function (err, status) {
                        console.log(err);
                    }
                });
            },
            //新增潜客
            jump() {
                this.$router.push("/insert");
            },
            //跳转签约
            jumpqian: function (url) {
                let self = this;
                self.$router.push({
                    name: url,
                    query: {
                        id: self.record_id,
                        type: 2 //跳转类型 区分从哪里跳转
                    }
                });
            },
            //无效用户
            void_user(done) {
                let that = this;
                this.$confirm("确认标记为无效用户？")
                    .then(_ => {
                        that.get_void();
                    })
                    .catch(_ => {
                    });
            },
            get_void() {
                let that = this;
                $.ajax({
                    url: process.env.apiUrl + "saas/nn/tagged_invalid_user",
                    type: "post",
                    data: {
                        token: that.token,
                        user_id: that.record_id
                    },
                    success: function (data, status) {
                        if (data.status == 1) {
                            that.popShow = false;
                            that.$message.success("标记无效用户成功");
                            that.getData(that.currentPage);

                        } else {
                            that.$message.error(data.msg);
                        }
                    },
                    fail: function (err, status) {
                        console.log(err);
                    }
                });
            },
            //表格数据
            getData(current_page, t) {
                const loading = this.$loading({
                    lock: true,
                    text: "加载中...",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)"
                });
                if (!current_page) {
                    current_page = 1;
                }
                let that = this;
                that.currentPage = current_page;
                let time_s = "",
                    time_e = "";
                if (this.now_time) {
                    time_s = this.now_time[0];
                    time_e = this.now_time[1];
                }
                $.ajax({
                    url: process.env.apiUrl + "saas/Qk/qkgj",
                    type: "post",
                    data: {
                        time_s: time_s,
                        time_e: time_e,
                        name: that.vip_name,
                        pname: that.cabeza_name,
                        pphone: that.cabeza_tel,
                        type: that.selectVal,
                        usertype: that.usertypeVal,
                        salesperson: that.select_Val,
                        laiy: that.select3Val,
                        page: that.currentPage,
                        yueling1: that.yueling1,
                        yueling2: that.yueling2,
                        orderby:that.orderby,
                        token: that.token
                    },
                    success: function (data, status) {
                        loading.close();
                        if (data.status == 1) {
                            that.tableData = data.data;
                            that.totalNum = data.map.count;
                            if (t && data.data != "") {
                                //删除所属顾问
                                that.market_num = data.data[0].num;
                            } else {
                                that.market_num = 0;
                            }
                        } else {
                            that.tableData = [];
                            that.totalNum = 0;
                        }
                        that.export_url = process.env.apiUrl + "saas/qk/export_qkgj?token=" + that.token + "&time_s=" + time_s
                            + "&time_e=" + time_e + "&name=" + that.vip_name + "&pname=" + that.cabeza_name + "&pphone=" + that.cabeza_tel
                            + "&type=" + that.selectVal + "&usertype=" + that.usertypeVal + "&salesperson=" + that.select_Val + "&laiy=" + that.select3Val + "&yueling1=" + that.yueling1 + "&yueling2=" + that.yueling2
                    },
                    fail: function (err, status) {
                        console.log(err);
                    }
                });
            },
            //姓名高亮
            getClass({row, column, rowIndex, columnIndex}) {
                if (columnIndex == 3) {
                    return "color:rgb(98, 158, 241)";
                }
            },
            //修改信息
            update(id) {
                this.dialogVisible = true;

                let that = this;
                $.ajax({
                    url: process.env.apiUrl + "saas/Qk/edit_qk_info",
                    type: "post",
                    data: {
                        user_id: id,
                        token: that.token
                    },
                    success: function (data, status) {
                        that.save_list = data.guanxi;
                        that.save_list2 = data.userinfo;
                        that.sheng = data.userinfo.sheng;
                        that.shi = data.userinfo.shi;
                        that.qu = data.userinfo.qu;
                        that.dz = data.userinfo.dz;
                        // 根据用户信息省市区 数字码 获取具体省市区名称
                        $.ajax({
                            type: "POST",
                            url: process.env.apiUrl + "saas/User/sheng",
                            data: {
                                token: that.$cookies.get("token"),
                                user_id: that.uid,
                                sheng: that.sheng
                            },
                            success: function (data) {
                                that.shiqu2 = data;
                            },
                            error: function () {
                                that.$message.error(`请求失败`);
                            }
                        });

                        $.ajax({
                            type: "POST",
                            url: process.env.apiUrl + "saas/User/sheng",
                            data: {
                                token: that.$cookies.get("token"),
                                user_id: that.uid,
                                sheng: that.shi
                            },
                            success: function (data) {
                                that.shiqu3 = data;
                            },
                            error: function () {
                                that.$message.error(`请求失败`);
                            }
                        });
                    },
                    fail: function (err, status) {
                        console.log(err);
                    }
                });
            },
            //确认修改
            confirm_save() {
                // 检查号码是否有重复
                if(this.phoneRepeat) {
                    return this.$message.error('请检查电话号码格式/是否存在重复')
                }
                this.dialogVisible = false;

                //提交修改表单
                var formData = new FormData($("#forms")[0]);
                let that = this;
                $.ajax({
                    url: process.env.apiUrl + "saas/Qk/update_qk_info",
                    type: "post",
                    async: false,
                    processData: false, // 不处理发送的数据，因为data值是Formdata对象，不需要对数据做处理
                    contentType: false, // 不设置Content-type请求头
                    data: formData,
                    success: function (data) {
                        if (data.status == 1) {
                            that.getData(that.currentPage);
                            that.pop(that.save_list2.user_id);
                            that.guanxiNum = 0;
                            that.$message.success("修改成功");
                        }
                    },
                    fail: function (err) {
                        console.log(err);
                    }
                });
            },
            //右侧弹出框
            pop(id) {
                document.documentElement.scrollTop = document.body.scrollTop = 0;
                this.popShow = true;
                this.record_id = id;

                let that = this;
                $.ajax({
                    url: process.env.apiUrl + "saas/nn/details",
                    type: "post",
                    data: {
                        userid: id,
                        token: that.token
                    },
                    success: function (data, status) {
                        that.popData = data.data;
                        that.follow_val = data.data.gj_type;
                    },
                    fail: function (err, status) {
                        console.log(err);
                    }
                });
                //跟进记录数据
                that.get_record(id);
                // 用户分类
                that.get_type();
            },
            blurs() {
                let that = this;
                setTimeout(function () {
                    that.showtype = false;
                }, 500);
            },
            // 用户分类
            get_type() {
                let that = this;
                $.ajax({
                    url: process.env.apiUrl + "saas/nn/usertype",
                    type: "post",
                    data: {
                        userid: that.record_id,
                        token: that.token
                    },
                    success: function (data, status) {
                        if (data.data) {
                            that.showtype2 = false;
                            that.t_name = data.data;
                        } else {
                            that.showtype2 = true;
                            that.t_name = "";
                        }
                    }
                });
            },
            get_type2(i) {
                let that = this;
                if (i == 1) {
                    var mag = "保存成功";
                } else {
                    var mag = "修改成功";
                }
                $.ajax({
                    url: process.env.apiUrl + "saas/nn/usertype",
                    type: "post",
                    data: {
                        userid: that.record_id,
                        token: that.token,
                        usertype: that.t_name
                    },
                    success: function (data, status) {
                        if (data.status == 1) {
                            that.$message.success(data.msg);
                            that.get_type();
                        }
                    }
                });
            },
            //跟进记录
            get_record(i) {
                let that = this;
                $.ajax({
                    url: process.env.apiUrl + "saas/nn/follow",
                    type: "post",
                    data: {
                        user_id: i,
                        token: that.token
                    },
                    success: function (data, status) {
                        if (data.status == 1) {
                            that.recordData = data.data;
                        } else {
                            that.recordData = [];
                        }
                    },
                    fail: function (err, status) {
                        console.log(err);
                    }
                });
            },
            //删除跟进记录
            del_record(id) {
                this.del_dialogVisible = true;
                this.del_id = id;
            },
            //确认删除记录
            confirm_del() {
                let that = this;
                $.ajax({
                    url: process.env.apiUrl + "saas/nn/del",
                    type: "post",
                    data: {
                        gj_id: that.del_id,
                        token: that.token
                    },
                    success: function (data, status) {
                        if (data.status == 1) {
                            that.del_dialogVisible = false;
                            that.$message.success(data.msg);
                            that.get_record(that.record_id);
                        }
                    },
                    fail: function (err, status) {
                        console.log(err);
                    }
                });
            },
            //多选
            handleSelectionChange(val) {
                let arr = [];
                for (let i in val) {
                    arr.push(val[i].user_id);
                }
                this.multipleSelection = arr;
            },
            //转给他人
            move() {
                if (!this.multipleSelection) {
                    this.$message.error("请先选择客户");
                } else {
                    this.DialogVisible = true;

                    let that = this;
                    //销售人员列表
                    $.ajax({
                        url: process.env.apiUrl + "saas/qk/yxlb",
                        type: "post",
                        data: {
                            token: that.token
                        },
                        success: function (data, status) {
                            if (data.status == 1) {
                                that.sellData = data.data;
                            } else {
                                that.$message.error(data.msg);
                            }
                        },
                        fail: function (err, status) {
                            console.log(err);
                        }
                    });
                }
            },
            //确认
            confirm_move() {
                if (!this.sell_name) {
                    this.$message.error("请先选择销售");
                } else {
                    let that = this;
                    $.ajax({
                        url: process.env.apiUrl + "saas/qk/zgtr",
                        type: "post",
                        data: {
                            user_id: that.multipleSelection,
                            uid: that.sell_name,
                            token: that.token
                        },
                        success: function (data, status) {
                            if (data.status == 1) {
                                that.DialogVisible = false;
                                that.$message.success(data.msg);

                                setTimeout(() => {
                                    that.getData();
                                }, 1000);
                            } else {
                                that.$message.error(data.msg);
                            }
                        },
                        fail: function (err, status) {
                            console.log(err);
                        }
                    });
                }
            },
            //发布
            issue() {
                if (!this.text_val) {
                    this.$message.error("请输入跟进内容");
                    return false;
                }
                if (!this.way_val) {
                    this.$message.error("请选择跟进方式");
                    return false;
                }
                if (!this.follow_val) {
                    this.$message.error("请选择跟进状态");
                    return false;
                }
                if (this.isSubmit) {
                    return;
                }
                this.isSubmit = true;
                let that = this;
                $.ajax({
                    url: process.env.apiUrl + "saas/nn/addfollow",
                    type: "post",
                    data: {
                        bao_id: that.record_id,
                        neirong: that.text_val,
                        fangshi: that.way_val,
                        st_time: that.make_time,
                        lasttime: that.last_time,
                        zhuangtai: that.follow_val,
                        token: that.token
                    },
                    success: function (data, status) {
                        if (data.status == 1) {
                            that.$message.success(data.msg);
                            //添加跟进记录
                            that.get_record(that.record_id);
                            that.getData(that.currentPage);

                            //清空已添加的跟进内容
                            that.text_val = ""; //文本域
                            that.way_val = ""; //跟进方式
                            that.week_val = ""; //跟进日期
                            that.make_time = ""; //预约时间
                            that.last_time = ""; //下次跟进时间
                            that.follow_val = ""; //跟进状态
                        } else {
                            that.$message.error(data.msg);
                        }
                    },
                    fail: function (err, status) {
                        console.log(err);
                    },
                    complete: function () {
                        that.isSubmit = false;
                    }
                });
            },
            //到访按钮
            visit(id1, key) {
                let that = this;
                $.ajax({
                    url: process.env.apiUrl + "saas/qk/dfqh",
                    type: "post",
                    data: {
                        id: id1,
                        token: this.token
                    },
                    success: function (data, status) {
                        if (data.status == 1) {
                            that.get_record(that.record_id);
                        }
                    },
                    fail: function (err, status) {
                        console.log(err);
                    }
                });
            },
            confirm_back() {
                this.send_state = false;

                let that = this;
                $.ajax({
                    url: process.env.apiUrl + "saas/qk/tuihui",
                    type: "post",
                    data: {
                        user_id: that.record_id,
                        token: that.token
                    },
                    success: function (data, status) {
                        if (data.status == 1) {
                            that.getData(that.currentPage);
                            that.popShow = false;
                            that.$message.success("已退回公海");
                        }
                    },
                    fail: function (err, status) {
                        console.log(err);
                    }
                });
            },
            //删除所属顾问
            del() {
                this.select_name = $(".select2")
                    .find("option:selected")
                    .text();
                if (!this.select_Val) {
                    this.$message.error("请先选择顾问");
                } else {
                    this.centerDialogVisible = true;
                }
            },
            del_market() {
                this.centerDialogVisible = false;

                let that = this;
                $.ajax({
                    url: process.env.apiUrl + "saas/qk/hg",
                    type: "post",
                    data: {
                        userid: that.select_Val,
                        token: that.token
                    },
                    success: function (data, status) {
                        if (data.status == 1) {
                            that.getData();
                        }
                    },
                    fail: function (err, status) {
                        console.log(err);
                    }
                });
            },
            //分页
            handleCurrentChange(val) {
                this.getData(val);
            },
            //清空搜索条件
            clear_search() {
                this.vip_name = "";
                this.cabeza_name = "";
                this.cabeza_tel = "";
                this.selectVal = "";
                this.usertypeVal = "";
                this.select_Val = "";
                this.select3Val = "";
                this.now_time = "";
                this.yueling1 = "";
                this.yueling2 = "";
                this.orderby = '';

                this.getData();
            },
            //根据星期选择课程
            week_save() {
                let that = this;
                $.ajax({
                    url: process.env.apiUrl + "saas/qk/xzkc",
                    type: "post",
                    data: {
                        date: that.make_time,
                        week: that.week_val,
                        token: that.token
                    },
                    success: function (data, status) {
                        that.courseData = data.data;
                    },
                    fail: function (err, status) {
                        console.log(err);
                    }
                });
            },
            shengxuan: function () {
                this.qu = "";
                let self = this;
                $.ajax({
                    type: "POST",
                    url: process.env.apiUrl + "saas/User/sheng",
                    data: {
                        token: self.token,
                        user_id: self.uid,
                        sheng: self.sheng
                    },
                    success: function (data) {
                        self.shiqu2 = data;
                    },
                    error: function () {
                        self.$message.error(`请求失败`);
                    }
                });
            },
            shixuan: function () {
                let self = this;
                $.ajax({
                    type: "POST",
                    url: process.env.apiUrl + "saas/User/sheng",
                    data: {
                        token: self.token,
                        user_id: self.uid,
                        sheng: self.shi
                    },
                    success: function (data) {
                        self.shiqu3 = data;
                    },
                    error: function () {
                        self.$message.error(`请求失败`);
                    }
                });
            },
            addGuanxi() {
                this.guanxiNum++;
            },
            delGuanxi(i) {
                if (i >= 0) {
                    this.save_list.splice(i, 1);
                } else if (this.guanxiNum > 0) {
                    this.guanxiNum--;
                }
            },
            checkRelation(e) {
                let r = e.target.value
                for (let i in this.save_list) {
                    if (r == this.save_list[i].g_value) {
                        this.$message.error(`请勿选择已有的关系`);

                        return
                    }
                }
            },
            checkPhone(e,indexkey) {
                this.phoneRepeat = false
                let phone = e.target.value
                for (let i in this.save_list) {
                    if (phone == this.save_list[i].p_phone && i != indexkey) {
                        this.$message.error(phone+'此号码列表中已存在')
                        this.phoneRepeat = true
                        return
                    }
                }
                let myreg=/^[0-9]{11}$/;
                if(!myreg.test(phone)){
                    this.$message.error({message:'格式错误,请输入正确手机号'})
                    return false;
                }else{
                    let that = this
                    $.ajax({
                        url: process.env.apiUrl +'saas/Qk/yz',
                        type: 'post',
                        data:{
                            phone:phone,
                            token:that.token,
                            user_id:that.record_id
                        },
                        success: function (data, status) {
                            if(data.status == 1){
                                that.$message.error({message:data.msg+'phone'})
                                that.phoneRepeat = true;
                            }
                        },
                        fail: function (err, status) {
                            console.log(err)
                        }
                    })
                }

                console.log('this.phoneRepeat', this.phoneRepeat)
            }
        }
    };
</script>


<style lang="less" scoped="scoped">
    .close-pop {
        width: calc(100% - 800px);
        height: 90vh;
        position: absolute;
        top: 0;
        left: 0;
    }

    .text_hidden {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
    }

    /*修改弹出框*/
    .el-dialog {

    .save-input {
        width: 160px;
        height: 28px;
        line-height: 28px;
        border-radius: 2px;
        border: 1px solid gainsboro;
        padding-left: 5px;
    }

    .el-date-editor.el-input,
    .el-date-editor.el-input__inner {
        width: 160px;
        margin-top: 10px;
    }

    .line {
        margin-top: 10px;

    .add {
        width: 20px;
        vertical-align: middle;
        text-align: center;
        font-weight: bolder;
        display: inline-block;
        background: #79c4c7;
        border-radius: 50%;
        color: white;
        font-size: 15px;
        cursor: pointer;
    }

    }
    }

    .fencss {
        padding: 0 8px;
        color: #fff;
        background-color: #E6BE8A;
        border: 0;
        border-radius: 2px;
    }

    /*确认删除*/
    .header .el-button--default {
        color: white;
    }

    #app {
        padding: 10px;
        position: relative;
    }

    .right-pop {
        width: 800px;
        height: 80vh;
        display: inline-block;
        position: absolute;
        background: white;
        border: 1px solid gainsboro;
        top: 0;
        right: 0;
        z-index: 99;

    .head {
        padding: 10px;

    .head-img {
        width: 35px;
        float: left;
    }

    .name {
        margin-top: 9px;
        margin-left: 8px;
        display: inline-block;
    }

    .right {
        float: right;
        margin-top: 5px;

    .move {
        display: inline-block;
        float: left;
        width: 85px;
        text-align: center;
        padding: 5px 0;
        border: 1px solid #adadad;
        border-radius: 2px;
        margin-right: 2px;
        cursor: pointer;
    }

    .el-button--text {
        float: left;
        width: 85px;
        text-align: center;
        padding: 7px 0;
        border: 1px solid #adadad;
        border-radius: 2px;
        color: black;
    }

    .close {
        margin-top: 5px;
        margin-left: 7px;
        margin-right: 5px;
        width: 20px;
    }

    }

    .head_content {
        margin-bottom: 7px;
        clear: both;

    span {
        display: inline-block;
        margin-left: 30px;
        padding-top: 12px;
    }

    }
    }

    .el-tabs--border-card {
        box-shadow: none;
    }

    textarea {
        width: 100%;
        height: 63px;
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 1s;
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }

    .el-tabs--border-card {
        border-left: 0;
        border-bottom: 0;
    }

    .down_form {
        margin-top: 15px;
        padding-bottom: 20px;
        height: 50vh;
        overflow: hidden;
        overflow-y: scroll;

    .el-date-editor.el-input,
    .el-date-editor.el-input__inner {
        width: 135px;
        margin-left: 5px;
        float: left;
    }

    .issue {
        padding: 3px 11px;
        color: #fff;
        background-color: #E6BE8A;
        border: 1px solid #E6BE8A;
        border-radius: 2px;
    }

    .record-content {
        margin-bottom: 10px;

    .record {
        height: 40px;
        line-height: 40px;
        margin-bottom: 10px;
        margin-top: 20px;
        padding-left: 20px;
        background-color: rgb(241, 241, 241);
        color: rgb(102, 102, 102);

    span {
        display: inline-block;
        padding-right: 50px;
    }

    .yet {
        width: 55px;
        line-height: 30px;
        background-color: #449d44;
        border: 0;
        border-radius: 5px;
        color: white;
        margin-left: 10px;
        font-size: 14px;
        cursor: pointer;
        outline: none;
    }

    .not {
        width: 55px;
        line-height: 30px;
        background-color: #f0ad4e;
        border: 0;
        border-radius: 5px;
        color: white;
        margin-left: 10px;
        font-size: 14px;
        cursor: pointer;
        outline: none;
    }

    }

    .header-img {
        float: left;
        margin: 0 15px;
        width: 50px;
    }

    .img-txt {
        display: inline-block;
        padding: 2px 5px;
        border-radius: 10px;
        color: #fff;
        background-color: #E6BE8A;
        border-color: #2e6da4;
        font-size: 14px;
        font-weight: bold;
        margin-top: 18px;
    }

    .right-txt {
        float: right;
        padding-top: 18px;
        padding-right: 30px;
        color: rgb(93, 156, 236);
        display: inline-block;
        cursor: pointer;
    }

    .content {
        padding-left: 84px;
        min-height: 50px;
        clear: both;
    }

    }
    }
    }

    .header {
        margin-bottom: 15px;

    .name {
        display: inline-block;
        height: 36px;
        padding-left: 16px;
        margin-left: 5px;
        font-size: 14px;
        line-height: 1.42857143;
        color: #555;
        background-color: #fff;
        border: 1px solid #ccc;
        border-radius: 4px;
    }

    .el-button {
        padding: 6px 14px;
        background-color: #E6BE8A;
        margin-left: 15px;
        margin-right: 6px;
        vertical-align: middle;
    }

    .refresh-btn {
        width: 43px;
        border: 1px solid #e4e7ed;
        line-height: 24px;
        background-color: white;
        border-radius: 2px;
        cursor: pointer;
        vertical-align: middle;
    }

    .delete {
        color: #fff;
        border: 0;
        background-color: #E6BE8A;
        display: inline-block;
        margin-bottom: 0;
        font-size: 14px;
        font-weight: 400;
        line-height: 1.42857143;
        text-align: center;
        border-radius: 3px;
        cursor: pointer;
        margin-left: 5px;
    }

    }

    .el-date-editor--daterange.el-input,
    .el-date-editor--daterange.el-input__inner,
    .el-date-editor--timerange.el-input,
    .el-date-editor--timerange.el-input__inner {
        width: 250px;
    }

    .el-icon-circle-plus-outline {
        color: blue;
        font-size: 20px;
        cursor: pointer;
    }

    .el-icon-remove-outline {
        color: red;
        font-size: 20px;
        cursor: pointer;
    }

    .ditialTxt {
        width: 70%;
        height: 40px;
        border-color: #dcdfe6;
        box-sizing: border-box;
        padding: 5px;
        vertical-align: middle;
    }
</style>



// WEBPACK FOOTER //
// src/pages/genjin/qianke.vue